import axios from 'axios';
import { envConfig } from '../../../env';

//Svn 本地地址
export const localServiceUrl = 'http://127.0.0.1:3343'
//Svn 远程地址
export const remoteServiceUrl = `http://${envConfig.svnIp}:9001`

// Svn Edge控制台
const edgeServiceUrl = `${envConfig.formalServer}/svnserver`


//SVN管理 - 测试服务器   Sidebar
const httpSvnUrl = `${envConfig.formalServer}/cotton`
// const httpSvnUrl = envConfig.formalServer + "/cotton"



//--- Sidebar.vue
export const svnLogin = params => axios.post(httpSvnUrl + '/svnLogin', params)              // 登录
export const svnLoginStatus = params => axios.post(httpSvnUrl + '/getLoginStatus', params)  // 获取 登录状态


//--- SvnStatus.vue
export const getHostStatus = params => axios.post(edgeServiceUrl + '/getHostStatus', params)  // 获取 主机状态
export const restartHost = params => axios.post(edgeServiceUrl + '/restartHost', params)  // 重启 主机
export const getEdgeStatus = params => axios.post(edgeServiceUrl + '/svnEdgeStatus', params)     // 获取 SvnEdge状态
export const operationEdge = params => axios.post(edgeServiceUrl + '/startOrStopEdgeTe', params) // 操作 SvnEdge服务 (启动或停止)
export const startEdgeLog = params => axios.post(httpSvnUrl + '/startEdgeLog', params)  // 保存 启动SvnEdge  日志
export const stopEdgeLog = params => axios.post(httpSvnUrl + '/stopEdgeLog', params)    // 保存 停止SvnEdge  日志

export const getServiceStatus = params => axios.post(httpSvnUrl + '/svnServiceStatus', params)    // 获取 SvnService状态
export const startService = params => axios.post(httpSvnUrl + '/startService', params) // 启动 SvnService服务
export const stopService = params => axios.post(httpSvnUrl + '/stopService', params)   // 停止 SvnService服务


//--- SvnManage.vue
export const getPersonnelInfoList = params => axios.post(httpSvnUrl + '/svnUserList', params)   // 获取 人员信息集合   -- SvnAuthorization.vue
export const deletePersonnelInfo = params => axios.post(httpSvnUrl + '/svnUserDelete', params)  // 删除 人员信息
export const getPersonnelInfo = params => axios.post(httpSvnUrl + '/svnUserEditShow', params)   // 获取 待修改人员信息  -- svnEdit.vue
//--- SvnEdit.vue
export const updatePersonnelInfo = params => axios.post(httpSvnUrl + '/svnEditUser', params, {  // 修改 人员信息
    headers: {
        'Content-Type': 'application/json'
    }
})


//--- SvnInsert.vue
export const postPersonnelInfo = params => axios.post(httpSvnUrl + '/svnUserSave', params, {          // 新增 人员信息
    headers: {
        'Content-Type': 'application/json'
    }
})

//--- SvnAuthorization.vue
export const getAuthorization = params => axios.post(httpSvnUrl + '/getAuthorization', params)        // 获取 访问规则文本
export const updateAuthorization = params => axios.post(httpSvnUrl + '/updateAuthorization', params)  // 修改 访问规则文本
export const getCNName = params => axios.post(httpSvnUrl + '/getCNName', params)       // 获取 中文备注
export const updateCNName = params => axios.post(httpSvnUrl + '/updateCNName', params) // 修改 中文备注


//--- SvnEditPersonal.vue
export const getPersonalInfo = params => axios.post(httpSvnUrl + '/getPersonalInfoId', params)        // 获取 个人信息
export const updatePersonalInfo = params => axios.post(httpSvnUrl + '/updatePersonalInfo', params, {  // 修改 个人信息
    headers: {
        'Content-Type': 'application/json'
    }
})





